$(document).ready(function() {
  // ------------------- TB_AboutUs_CMS Start -------------------
  var TB_aboutus_products = $('#tb-about-us-toy').owlCarousel({
                items : 2, //1 items above 1000px browser width
                nav :true,
                dots : false,
                loop: false,
                autoplay:false, 
                // rtl:rtlVal,
                responsive:{
                    0:{
                        items:1
                    },
                    768:{
                        items:2
                    },
                    992:{
                        items:2
                        
                    }
                }
            });
   // ------------------- TB_Services_CMS Start -------------------
         var tb_services_cms = $('#tb-services-cms .tb-services-cms-wrapper').owlCarousel({
            items : 4, //1 items above 1000px browser width
            nav: false,
            dots: false,
            loop: false,
            center: false,
            autoplayHoverPause: true,
            autoplay:true,
            // rtl:rtlVal,
            responsive: {
                    0:{
                        items:1
                    },
                    544:{
                        items:2
                    },
                    768:{
                        items:2
                    },
                    992:{
                        items:3
                    },
                    1200:{
                        items:4
                    }
                }
        });
  // ------------------- TB_Services_CMS End -------------------
  // ------------------- TB-Gallery-CMS Start -------------------
        var tb_gallery_cms = $('#gallery').owlCarousel({
                  items : 4, //1 items above 1000px browser width
                  nav: false,
                  dots: false,
                  loop: false,
                  center: false,
                  autoplayHoverPause: true,
                  autoplay:true,
                  // rtl:rtlVal,
                  responsive: {
                          0:{
                              items:2
                          },
                          481:{
                              items:3
                          },
                          768:{
                              items:4
                          },
                          992:{
                              items:5
                          },
                          1200:{
                              items:6
                          }
                      }
              });
        // ------------------- TB-Gallery-CMS End -------------------
    // ------------------- TB_Testimonial-CMS Start -------------------
        var tb_testimonial_cms = $('#tb-testimonial-cms .tb-testimonial-flex').owlCarousel({
            items : 1, //1 items above 1000px browser width
            nav: true,
            dots: false,
            loop: false,
            autoplayHoverPause: true,
            autoplay:true,
            // rtl:rtlVal,
            responsive: {
                    0:{
                        items:1
                    },
                    544:{
                        items:1
                    },
                    768:{
                        items:1
                    },
                    992:{
                        items:1
                    },
                    1200:{
                        items:1
                    }
                }
        });
        // ------------------- TB_Testimonial-CMS End -------------------
        // ------------------- TB_category_featured Start -------------------
               var TB_category_featured = $('#TB-category-featured .tb-category-featured-carousel').owlCarousel({
                items : 4, //1 items above 1000px browser width
                nav :false,
                dots : false,
                loop: true,
                autoplay: true,
                autoplayHoverPause: true,
                // rtl:rtlVal,
                responsive: {
                    0:{
                        items:1
                    },
                    544:{
                        items:2
                    },
                    768:{
                        items:2
                    },
                    992:{
                        items:3
                    },
                    1300:{
                        items:4
                    }
                }
            });
        // ------------------- TB_category_featured End -------------------
});